import { BaseApiService } from '@shared/services/BaseApiService';

class StatServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  getGeneral(params) {
    return this.http.get('/general', { params: params });
  }

  getDetailed(params) {
    return this.http.get('/detailed', { params: params }).then((respponse) => {
      return {
        meta: respponse.meta,
        data: respponse.data.map((i) => ({
          ...i,
          source_incoming: i.source_incoming.replace(/\+/g, ''),
          source_outgoing: i.source_outgoing.replace(/\+/g, '')
        }))
      };
    });
  }
}

export const StatService = new StatServiceClass({
  api_version: 2,
  resource: 'stats/voice'
});
